// filepath: /home/jake/DRC/map/src/components/Map/MouseCoordinatesDisplay.tsx
import React from 'react';
import './styles.css'; // Assuming styles are in the same directory

interface MouseCoordinatesDisplayProps {
  coordinates: { lat: number; lng: number } | null;
}

const MouseCoordinatesDisplay: React.FC<MouseCoordinatesDisplayProps> = ({ coordinates }) => {
  if (!coordinates) {
    return null; // Don't render anything if coordinates are null
  }

  // Format coordinates to a fixed number of decimal places
  const lat = coordinates.lat.toFixed(6);
  const lng = coordinates.lng.toFixed(6);

  return (
    <div className="mouse-coordinates-display">
      Lat: {lat}, Long: {lng}
    </div>
  );
};

export default MouseCoordinatesDisplay;